import { DataHubActions } from '../../dataHubActions';
import { DataHubEntities } from '../../dataHubEntities';
import { BaseClickSchema } from '../baseClickSchema';
export class ClickContentSearchSchema extends BaseClickSchema {
    constructor() {
        super({
            componentName: 'SEARCH_INPUT'
        });
        Object.defineProperty(this, "action", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "entity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.action = DataHubActions.ClickContentSearch;
        this.entity = DataHubEntities.Admin;
    }
    getDataHubEventData() {
        return {
            ...super.prepare()
        };
    }
}
